/* biome-ignore-all lint/style/noParameterAssign: Need to pass ref for forwardRef */
// TODO: This probably shouldn't be here either
'use client';

import { Slot } from '@radix-ui/react-slot';
import { forwardRef } from 'react';
import { tv, type VariantProps } from 'tailwind-variants';
import { cn } from '@/app_lib/utils/utils';

const button = tv({
  base: 'group/button inline-flex uppercase items-center justify-center active:shadow-btn-shadow active:shadow-sm focus-visible:shadow-btn-shadow gap-2 whitespace-nowrap font-medium focus-visible:shadow-sm transition-colors [&_*]:transition-colors focus-visible:outline-none disabled:cursor-not-allowed disabled:pointer-events-none disabled:opacity-50 text-base cursor-pointer font-graphik-compact',
  defaultVariants: {
    size: 'sm',
  },
  variants: {
    size: {
      lg: 'px-12 py-3.5 text-base',
      sm: 'px-12 py-3 text-base',
      xs: 'btn-xs',
    },
    variant: {
      accent: 'bg-accent-secondary text-neutral-50 hover:bg-accent-secondary-700 focus-visible:ring-error-500',
      externalService: 'border-none bg-neutrals-100 hover:bg-neutrals-200 active:shadow-none',
      icon: 'btn-icon',
      primary: 'bg-inverse hover:bg-inverse-hover text-white focus-visible:ring-btn-primary-50',
      secondary:
        'bg-neutral-50 border-1 border-btn-primary text-btn-primary hover:bg-neutral-300 focus-visible:ring-btn-primary',
      tertiary:
        'text-accent-primary focus-visible:ring-accent-primary bg-transparent hover:underline active:ring-1 shadow-none focus-visible:shadow-none active:shadow-none gap-0',
    },
  },
});

type ButtonVariants = VariantProps<typeof button>;

interface ButtonProps extends ButtonVariants, React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  asChild?: boolean;
  className?: string;
  icon?: string;
}

// TODO: Remove this and replace with ButtonV2
/**
 * DEPRECATED: DO NOT USE (Use ButtonV2 instead).
 */
const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, children, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button';

    return (
      <Comp
        className={cn(button({ size, variant }), className)}
        ref={ref}
        {...props}
      >
        {children}
      </Comp>
    );
  },
);
Button.displayName = 'Button';

export { Button };
